module.exports = __webpack_public_path__ + "static/img/oddnary_bg_login.e2edae46.jpg";